import { render, staticRenderFns } from "./folder-update.vue?vue&type=template&id=33a12299&scoped=true"
import script from "./folder-update.vue?vue&type=script&lang=js"
export * from "./folder-update.vue?vue&type=script&lang=js"
import style0 from "./folder-update.vue?vue&type=style&index=0&id=33a12299&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a12299",
  null
  
)

export default component.exports